declare global {
    interface Window {
        Android?: {
            postMessage: (message: string) => void
        }
        webkit?: {
            messageHandlers?: {
                driveeiOSHandler?: {
                    postMessage: (message: unknown) => void
                }
            }
        }
    }
}

export const isIos = (): boolean => {
    return (
        globalThis.window !== undefined &&
        globalThis.window.webkit?.messageHandlers?.driveeiOSHandler !== undefined
    )
}

export const isAndroid = (): boolean => {
    return globalThis.window !== undefined && globalThis.window.Android !== undefined
}

export const isNativeApp = (): boolean => isIos() || isAndroid()

export const postMessageToApp = (message: unknown): void => {
    const iosHandler = globalThis.window?.webkit?.messageHandlers?.driveeiOSHandler

    if (iosHandler) {
        iosHandler.postMessage(message)

        return
    }

    const androidBridge = globalThis.window?.Android

    if (androidBridge) {
        androidBridge.postMessage(JSON.stringify(message))
    }
}

/** Просит нативное приложение закрыть WebView. */
export const dismissApp = (): void => {
    if (!isNativeApp()) {
        return
    }

    postMessageToApp({ action: 'dismiss', data: { toast: '', sync_profile: false } })
}
